module.exports = __webpack_public_path__ + "static/media/banner1.8bc698de.png";